module.exports = __webpack_public_path__ + "static/assets/936ad06e211818634bbd72905bac480d.svg";